import { useMemo } from "react";
import { Link } from "react-router-dom";
import { ArrowDownUp, Trash2 } from "lucide-react";

interface ColumnsProps {
  handleUpdateDataClick: (data: any) => void;
  handlerUpdate: (data: any) => void;
}

const PaymentFarmerForopColumn = ({
  handleUpdateDataClick,
  handlerUpdate,
}: ColumnsProps) => {
  const PaymentFarmerForopColumn = useMemo(
    () => [
      {
        header: "بابت",
        accessorKey: "forWhate",
        enableColumnFilter: false,
      },
      {
        header: "عنوان",
        accessorKey: "title",
        enableColumnFilter: false,
        cell: ({ getValue }: { getValue: () => any }) => {
          const value = getValue();
          return value ? value.toLocaleString("fa-IR") : "0";
        },
      },
      {
        header: "مبلغ",
        accessorKey: "price",
        enableColumnFilter: false,
        cell: ({ getValue }: { getValue: () => any }) => {
          const value = getValue();
          return value ? value.toLocaleString("fa-IR") : "0";
        },
      },

      {
        header: () => (
          <span className="flex">
            تاریخ پرداخت
            <ArrowDownUp size={15} className="text-gray-500 gap-2" />
          </span>
        ),
        accessorKey: "date",
        enableColumnFilter: false,
        cell: ({ getValue }: { getValue: () => any }) => {
          const value = getValue();
          return value ? value.toLocaleString("fa-IR") : "0";
        },
      },

      {
        header: "تاریخ ثبت",
        accessorKey: "created_reister",
        enableColumnFilter: false,
        cell: ({ getValue }: { getValue: () => any }) => {
          const value = getValue();
          return value ? value.toLocaleString("fa-IR") : "0";
        },
      },
      {
        header: "عملیات",
        enableColumnFilter: false,
        enableSorting: true,
        cell: (cell: any) => (
          <div className="flex gap-3">
            <Link
              to="#!"
              data-modal-target="addEmployeeModal"
              className="flex items-center justify-center size-8 transition-all duration-200 ease-linear rounded-md edit-item-btn bg-slate-100 text-slate-500 hover:text-custom-500 hover:bg-custom-100 dark:bg-zink-600 dark:text-zink-200 dark:hover:bg-custom-500/20 dark:hover:text-custom-500"
              onClick={() => {
                const data = cell.row.original;
                handlerUpdate(data);
              }}
            >
              <span className="rounded p-1 w-20 ml-3 bg-custom-500 text-white">
                ویرایش
              </span>
            </Link>
            <Link
              to="#!"
              className="flex items-center mr-4 justify-center size-8 transition-all duration-200 ease-linear rounded-md remove-item-btn bg-slate-100 text-slate-500 hover:text-custom-500 hover:bg-custom-100 dark:bg-zink-600 dark:text-zink-200 dark:hover:bg-custom-500/20 dark:hover:text-custom-500"
              onClick={() => {
                const data = cell.row.original;
                handleUpdateDataClick(data);
              }}
            >
              <span className="rounded p-1 w-20 ml-3 bg-red-800 text-white">
                حذف
              </span>
            </Link>
          </div>
        ),
      },
    ],
    []
  );

  return PaymentFarmerForopColumn;
};

export default PaymentFarmerForopColumn;
